import React from "react";
import { useTranslation } from "react-i18next";

import { home_categories_content } from "utils/constants/data";

const Categories = () => {
  const { t } = useTranslation();
  return (
    <div id="categoriesContainer">
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl app-animation-translate-start section-title">
            {t("categories")}
          </p>
          <div className="max-w-5xl mx-auto text-sm sm:text-base">
            <div className="flex flex-col justify-center gap-10 lg:flex-row lg:items-stretch app-animation-translate-start">
              {home_categories_content?.map((category, i) => {
                const { image_url, contents } = category || {};
                return (
                  <div
                    key={i}
                    className="flex flex-col lg:flex-row items-center lg:items-start gap-8 border border-lime-500 rounded-2xl p-8 w-full lg:w-[48%] shadow-sm hover:shadow-md transition-all h-full lg:min-h-[320px]"
                  >
                    <div className="flex justify-center flex-shrink-0 lg:justify-start">
                      <img
                        src={image_url}
                        alt={`Category-${i + 1}`}
                        className="object-contain h-auto w-28 lg:w-32 lg:h-auto"
                      />
                    </div>
                    {contents}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Categories;
